/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Selfdestruct_SequenceInputs */

const en_selfdestruct_sequence = /** @type {(inputs: Selfdestruct_SequenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Self-Destruct Sequence`)
};

const es_selfdestruct_sequence = /** @type {(inputs: Selfdestruct_SequenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secuencia de autodestrucción`)
};

const fr_selfdestruct_sequence = /** @type {(inputs: Selfdestruct_SequenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séquence d'autodestruction`)
};

const de_selfdestruct_sequence = /** @type {(inputs: Selfdestruct_SequenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selbstzerstörungssequenz`)
};

const ja_selfdestruct_sequence = /** @type {(inputs: Selfdestruct_SequenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自爆シーケンス (アカウント削除)`)
};

const zh_selfdestruct_sequence = /** @type {(inputs: Selfdestruct_SequenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自毁程序`)
};

const ar_selfdestruct_sequence = /** @type {(inputs: Selfdestruct_SequenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسلسل التدمير الذاتي`)
};

const id_selfdestruct_sequence = /** @type {(inputs: Selfdestruct_SequenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urutan Hancur Sendiri`)
};

const it_selfdestruct_sequence = /** @type {(inputs: Selfdestruct_SequenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sequenza di Autodistruzione`)
};

const ru_selfdestruct_sequence = /** @type {(inputs: Selfdestruct_SequenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запуск самоуничтожения`)
};

const pt_selfdestruct_sequence = /** @type {(inputs: Selfdestruct_SequenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sequência de Autodestruição`)
};

const ko_selfdestruct_sequence = /** @type {(inputs: Selfdestruct_SequenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자폭 시퀀스 (계정 삭제)`)
};

/**
* | output |
* | --- |
* | "Self-Destruct Sequence" |
*
* @param {Selfdestruct_SequenceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const selfdestruct_sequence = /** @type {((inputs?: Selfdestruct_SequenceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Selfdestruct_SequenceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_selfdestruct_sequence(inputs)
	if (locale === "es") return es_selfdestruct_sequence(inputs)
	if (locale === "fr") return fr_selfdestruct_sequence(inputs)
	if (locale === "de") return de_selfdestruct_sequence(inputs)
	if (locale === "ja") return ja_selfdestruct_sequence(inputs)
	if (locale === "zh") return zh_selfdestruct_sequence(inputs)
	if (locale === "ar") return ar_selfdestruct_sequence(inputs)
	if (locale === "id") return id_selfdestruct_sequence(inputs)
	if (locale === "it") return it_selfdestruct_sequence(inputs)
	if (locale === "ru") return ru_selfdestruct_sequence(inputs)
	if (locale === "pt") return pt_selfdestruct_sequence(inputs)
	return ko_selfdestruct_sequence(inputs)
});